import { gqlClient } from '../../components/AppProvider';
import { AppDispatch, AppThunk } from '../../store';
import { PagingResultModelOfTransactionErrorModel, GetTransactionErrorsInput, RequestResult, ExceptionStatus, UpdateTransactionErrorsInput } from '../../gql-types.generated';
import { queryErrorLogList } from "../../gql/QueryErrorLogList";
import { captureUpdateLogsStatus, clearError, decrementErrorLogRequestsInFlight, fetchError, fetchErrorLogListSuccess, incrementErrorLogRequestsInFlight, setCurrentPage, selectPageCursors } from './ErrorLogsSlice';
import { getErrorMessage } from '../../util/Common';
import { mutationUpdateTransactionErrorStatus } from '../../gql/MutationUpdateTransactionErrorStatus';
import { serializeError } from '../../util/ErrorSerialization';

// Unified pagination action
export const fetchErrorLogList = (
    targetPage: number,
    filters?: GetTransactionErrorsInput
): AppThunk => async (dispatch: AppDispatch, getState): Promise<void> => {
    const state = getState();
    const pageCursors = selectPageCursors(state);
    
    // Clear any previous error when starting a new fetch
    dispatch(clearError());
    
    // Set the current page first
    dispatch(setCurrentPage(targetPage));
    
    // Determine the cursor to use - cursor gets you TO the target page
    let cursor: string | undefined;
    if (targetPage === 1) {
        cursor = undefined; // First page uses no cursor
    } else {
        // For page N, we need the cursor from page N-1 that points to page N
        cursor = pageCursors[targetPage];
    }
    
    // Update filters with the cursor
    const updatedFilters = {
        ...filters,
        after: cursor
    };
    
    dispatch(incrementErrorLogRequestsInFlight());
    try {
        const errorLogList = await queryErrorLogList(gqlClient, updatedFilters);
        if (errorLogList) {
            dispatch(fetchErrorLogListSuccess(errorLogList as PagingResultModelOfTransactionErrorModel))
        }
        dispatch(decrementErrorLogRequestsInFlight());
    } catch (e) {
        dispatch(fetchError(serializeError(e as Error)));
        dispatch(decrementErrorLogRequestsInFlight());
    }
};

export const updateTransactionErrorStatus = (updateData: UpdateTransactionErrorsInput): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const updateStatus = await mutationUpdateTransactionErrorStatus(gqlClient, updateData);
            if (updateStatus) {
                if (updateStatus.result === RequestResult.Fail) {
                    getErrorMessage(updateStatus.message as string, updateStatus.errors, true, true);
                }
                dispatch(captureUpdateLogsStatus(updateStatus));
            }
        } catch (e) {
            dispatch(fetchError(serializeError(e as Error)));
        }

    };

